import { CxAlertsService } from "./cx-alerts.service";
import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-cx-alerts",
  templateUrl: "./cx-alerts.component.html",
  styleUrls: ["./cx-alerts.component.scss"],
})
export class CxAlertsComponent implements OnInit {
  @Input()
  messageText: string;
  @Input()
  type: string;
  @Input() closeable = true;
  public alertType: string;
  public iconType: string;
  private alertTypeSave: string;

  constructor(private alertService: CxAlertsService) {}

  ngOnInit(): void {
    this.alertType = `cx_alerts__type--${this.type}`;
    this.iconType = this.type;
  }

  closeAlert(): void {
    this.alertService.closeAlert(this.type);
  }
}
